$(document).ready(function(){
  $('.section-block--product-descripation-tab .product-tab:first').addClass('current-tab');
 $('.section-block--product-details .product-tab-main:not(:first)').addClass('is-hidden-tab');
  $( '.product-tab' ).on( 'click', function() {  
    var $product_tab = $(this).attr('data-product-tab');  
    if ( $product_tab == 'all' ) {
      $( '.product-tab-main' ).removeClass('is-hidden-tab');    
    } else {
      $( '.product-tab-main' ).addClass( 'is-hidden-tab' );
      $( '.product-tab-main[data-product-tab=' + $product_tab + ']').removeClass('is-hidden-tab');
    }
    // Add class "current" to the matching .faq-heading div
    $('.product-tab[data-product-tab]').removeClass('current-tab'); // Remove the class from all .faq-heading divs first
    $('.product-tab[data-product-tab="' + $product_tab + '"]').addClass('current-tab'); // Add the class to the matching .faq-heading div 
    $('.img-gal.slick-slider').slick('refresh');   
  });


  var maxHeight = 200;
  var isDesktop = window.matchMedia('(min-width: 769px)').matches;
  if (isDesktop) {
    $('.productFormDetails_main-section').addClass('expanded');
    $('.productFormDetails_main-desc').addClass('show-more');
  } else {
    if ($('.productFormDetails_main-section').height() > maxHeight) {
      $('#readMoreBtn').show();
    }
    $('#readMoreBtn').click(function() {
      $('.productFormDetails_main-section').toggleClass('expanded');
      $('.productFormDetails_main-desc').toggleClass('show-more');
      $(this).text(function(i, text) {
        return text === 'Read More' ? 'Read Less' : 'Read More';
      });
    });
  }
  

  
$('[data-product-tab="description"] .img-gal').not('.slick-initialized').slick({
    slidesToShow:4,
    slidesToScroll:2,
    autoplay: true,
    infinite:true,    
  	arrows: true,
    adaptiveHeight: false,
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }   
  ]
  }); 

$('.pr-container .slider-press').slick({
    slidesToShow:2,
    slidesToScroll:2,
    autoplay: true,
    infinite:true,    
  	arrows: false,
    adaptiveHeight: false,
    responsive: [
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }   
  ]
  }); 
  
}); 